export default __webpack_public_path__ + "static/media/icon_question-circle_bleu.871db443.svg";